import { createContext, useContext } from 'react'
import api from '../../services/api'

// ══════════════════════════════════════════════════════════════════════════════════════════════
//  DÓNDE SE ESTÁ VIENDO LA FORMACIÓN: la del equipo de una clínica o la de una persona invitada   (B-2283 · t535 · 28-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  Las MISMAS pantallas (Portada, Bloque, Leccion, el reproductor, la bienvenida) sirven a las dos. Lo único que cambia:
//   · `api`: el cliente con el que se piden las lecciones. El del equipo (services/api, /api/formacion) o el de la persona
//     invitada (services/apiFormacionInvitado, /api/formacion-invitados, con su sesión propia);
//   · `base`: dónde viven las direcciones de la Formación (/formacion o /formacion/acceso);
//   · `invitado`: si quien mira es una cuenta de solo Formación (no hay equipo que vea su progreso);
//   · `sello`: lo que se pinta encima del vídeo además de «Formación Biango» (el correo de la persona invitada; en el equipo,
//     nada: el dueño, 14-oct, «debe salir "Formación Biango" nada más»).
//  Sin proveedor (la Formación de las clínicas de siempre), lo de fábrica: exactamente lo de antes.
export const ENTORNO_EQUIPO = Object.freeze({ api, base: '/formacion', invitado: false, sello: null })
export const EntornoFormacion = createContext(ENTORNO_EQUIPO)
export function useEntornoFormacion() {
  return useContext(EntornoFormacion) || ENTORNO_EQUIPO
}
